import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import db from '../db'
import Layout from '../Layouts/Layout'
import { Helmet } from 'react-helmet-async'

export default function Course () {
  const title = useParams().title
  const course = db.courses.find(c => c.title === title)

  window.scroll(0, 0)

  useEffect(() => {}, [])

  return (
    <Layout>
      <Helmet>
        <title>{course.name} | Kodart Tətbiq və Təlim Mərkəzi</title>
        <meta name="description" content={course.description} />
        <link rel="canonical" href={`https://kodart.az/təlim/${course.title}`} />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="az_AZ" />
        <meta property="og:url" content={`https://kodart.az/təlim/${course.title}`} />
        <meta property="og:title" content={`${course.name} | Kodart`} />
        <meta property="og:description" content={course.description} />
        <meta property="og:image" content={`https://kodart.az${course.image}`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${course.name} | Kodart`} />
        <meta name="twitter:description" content={course.description} />
        <meta name="twitter:image" content={`https://kodart.az${course.image}`} />
      </Helmet>
      <main data-page='course' className='page-container'>
          <section className='section-container general-informations'>
            <h1 className='course-header'>{course.name}</h1>
            <div className='row'>
              <div className='col-12 col-sm-12 col-md-6'>
                <div className='course-subjects'>
                  {course.subjects.map((s, i) => {
                    return (
                      <span key={i} className='subject-tag'>
                        {s}
                      </span>
                    )
                  })}
                </div>
                <p className='course-description'>{course.description}</p>
                <p className='course-duration'>
                  <b>Kursun müddəti:</b> {course.duration}
                </p>
                <div className='course-program'>
                  <b>Proqram:</b>
                  <ul>
                    {course.program
                      .sort((a, b) => +a.order - +b.order)
                      .map((s, i) => {
                        return (
                          <li key={i}>
                            <h5>
                              <img src="/Images/Icons/checked.png" className='check-icon' alt="check icon"/>
                              {s.subject}
                            </h5>
                          </li>
                        )
                      })}
                  </ul>
                </div>
              </div>
              <div className='col-0 col-sm-0 col-md-6'>
                <div className='course-image'>
                  <img src={course.image} alt={course.name}/>
                </div>
              </div>
            </div>
          </section>
        </main>
      </Layout>
  )
}
